import { createStore } from "@reduxjs/toolkit";
import reducers from "./reducers";
import { composeWithDevTools } from "@redux-devtools/extension";

const store = createStore(reducers, composeWithDevTools());

export default store;